import * as React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import * as Glob from '../Globale';
import { Trad } from '.';

interface IHTMLEditorProps {
    Name: string;
    Value: string;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => void;
    CampoWordMassimoUnaTabella?: boolean;
}


export const HTMLEditor: React.FC<IHTMLEditorProps> = (props) => {
    const OnChange = (e: any) => {
        props.OnChange(props.Name, e.target.getContent());
    }

    const OnBlur = (e: any) => {
        if (props.CampoWordMassimoUnaTabella ?? false) {
            if ((e.target.getContent().match(/<table>|<table /g) || []).length > 1) {
                Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.Trad("CampoWordMassimoUnaTabella"));
            }
        }
    }

    return (
        <Editor
            apiKey="dhz6s13zxawhy1uy2w1cdpb7r43mvkrjbzqzlqbb25vhzw8u"
            initialValue={props.Value}
            init={{
                language_url: Glob.GetLocale().Lingua == "it" ? "/TinyMCE/it_IT.js" : "",
                language: Glob.GetLocale().Lingua == "it" ? "it_IT" : "en_GB",
                height: 500,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help'
            }}
            onChange={OnChange}
            onBlur={OnBlur}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/HTMLEditor.tsx